import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { checkTokens } from 'services/auth'
import { StoreThunkAction, StoreThunkDispatch } from 'store/state'
import { V1 } from './net'
import { PPProduct } from 'shared'

export function getPlans(): StoreThunkAction<Observable<PPProduct[]>> {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(checkTokens()).pipe(map((response: any) => response.subscriptions.products as PPProduct[]))
  }
}

export function updatePlan(plan: PPProduct) {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.updatePlan(plan))
  }
}
